export class MercadoriasVariedadesModel {
  id: number;
  nome: string;
  id_mercadoria: number = 0;
  plu: number;
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-variedades/mercadorias-variedades.model.ts